export const TerminationEngagementRoutes = publicConfiguration.isOAuthEnabled() ? [
    {
        "url": "/guest-touchpoint/:touchpoint_id?hauth-token&type",
        "name": "guestTouchpoint",
        "type": "frontend",
        "loginRequired": false,
        "component": "terminationTouchpointComponent",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/termination-engagement/termination-engagement.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
            { type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` },
        ],
    }
] : [];
//# sourceMappingURL=termination-engagement.routes.js.map